import { render, staticRenderFns } from "./ContractDetailsPayments.vue?vue&type=template&id=4569dbec&scoped=true"
import script from "./ContractDetailsPayments.vue?vue&type=script&lang=js"
export * from "./ContractDetailsPayments.vue?vue&type=script&lang=js"
import style0 from "./ContractDetailsPayments.vue?vue&type=style&index=0&id=4569dbec&prod&lang=scss&scoped=true"
import style1 from "./ContractDetailsPayments.vue?vue&type=style&index=1&id=4569dbec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4569dbec",
  null
  
)

export default component.exports